/** User */
export const GET_USER = 'GET_USER';
export const NO_USER_FOUND = 'NO_USER_FOUND';
export const RESET_USER = 'RESET_USER';
export const USER_IS_LOADING = 'USER_IS_LOADING';
export const IS_LOADING_MESSAGE = 'IS_LOADING_MESSAGE';
export const PROGRESS_UPLOADING_PERCENTAGE = 'PROGRESS_UPLOADING_PERCENTAGE';
